import {
  ORGANISATION_FETCHED,
  QUOTES_FETCHED,
  ORG_LOANS_FETCHED
} from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case ORGANISATION_FETCHED: {
      const { organisation: newOrg } = action.data;
      const oldOrg = state[newOrg.id];
      return { ...state, [newOrg.id]: { ...oldOrg, ...newOrg } }; // Keep the quotes from the old org
    }
    case QUOTES_FETCHED: {
      const { quotes, orgId } = action.data;
      const organisationWithQuotes = { ...state[orgId], quotes }
      return { ...state, [orgId]: organisationWithQuotes };
    }
    case ORG_LOANS_FETCHED: {
      const { loans, orgId } = action.data;
      const organisationWithLoans = { ...state[orgId], loans }
      return { ...state, [orgId]: organisationWithLoans };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/organisations.js